import Vue from 'vue';
import { dateRangeDiffDesc } from 'src/utils/dates';
const DashboardChangesTooltip = Vue.extend({
    props: {
        dateRangeDiff: { type: Object, required: false, default: () => null },
        themesDiff: { type: Object, required: false, default: () => null },
        filterDiff: { type: Object, required: false, default: () => null },
        modifiedOverviewWidgets: { type: Array, required: false, default: () => [] },
        modifiedDrilldownWidgets: { type: Array, required: false, default: () => [] },
        dateFiltersChanged: { type: Boolean, required: false, default: false },
        groupByDiff: { type: Object, required: false, default: () => null },
        speakerFieldDiff: { type: Object, required: false, default: () => null },
        compareModeNewValue: { type: Boolean, required: false, default: undefined },
    },
    computed: {
        filterDiffDescription() {
            return this.diffDescription(this.filterDiff?.added?.length, this.filterDiff?.removed?.length);
        },
        compareFilterDiffDescription() {
            return this.diffDescription(this.filterDiff?.compareAdded?.length, this.filterDiff?.compareRemoved?.length);
        },
        themesDiffDescription() {
            return this.diffDescription(this.themesDiff?.added?.length, this.themesDiff?.removed?.length);
        },
        dateFilterInfo() {
            if (this.dateRangeDiff) {
                const desc = dateRangeDiffDesc(this.dateRangeDiff.original, this.dateRangeDiff.current);
                return `from '${desc.original}' to '${desc.current}'`;
            }
            return '';
        }
    },
    methods: {
        diffDescription(added = 0, removed = 0) {
            let desc = '';
            if (added > 0)
                desc = `${added} added`;
            if (added > 0 && removed > 0)
                desc = `${desc}, `;
            if (removed > 0)
                desc = `${desc}${removed} removed`;
            return desc;
        }
    }
});
export default DashboardChangesTooltip;
